import { createFeatureSelector } from '@ngrx/store';
import { UserSettingsState } from './features/user-settings/user-settings-state';
import {TrainingStoreState} from "./features/training/training-state";

export const selectUserSettingsFeature = createFeatureSelector<UserSettingsState>('userSettings');
export const selectTrainingFeature = createFeatureSelector<TrainingStoreState>('training');
